import type { ShipmentOrderType } from "./shipment-options.types";

export const REPLACEMENT_ORDER_TYPE: ShipmentOrderType = "LCR";
